import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    addPasskey,
    addSocialLink,
    logout,
    removeSocialLink,
    removeSocialLinkCancelled,
    removeSocialLinkConfirmed,
    sessionExpired,
    sessionExpiredConfirmed
} from './login.actions';
import { Injectable } from '@angular/core';
import { merge } from 'rxjs';
import { filter, map, mergeMap, take, tap } from 'rxjs/operators';
import { AuthService } from '../../modules/shared/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { SessionExpiredModalComponent } from '../../modules/shared/session-expired-modal/session-expired-modal.component';
import { profileClearCache } from '../profile/profile.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../index';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class LoginEffects {

    constructor(private actions$: Actions, private authService: AuthService,
                private dialog: MatDialog, private store: Store<AppState>, private snackbar: MatSnackBar) {
    }

    logout$ = createEffect(() => this.actions$.pipe(
        ofType(logout),
        tap(() => this.authService.redirectToLogout())
    ), { dispatch: false });

    sessionExpired$ = createEffect(() => this.actions$.pipe(
        ofType(sessionExpired),
        tap(() => {
            this.store.dispatch(profileClearCache());
            const ref = this.dialog.open(SessionExpiredModalComponent, { disableClose: true });
            ref.afterClosed().subscribe(() => {
                this.store.dispatch(sessionExpiredConfirmed());
            });
        })
    ), { dispatch: false });

    sessionExpiredConfirmed$ = createEffect(() => this.actions$.pipe(
        ofType(sessionExpiredConfirmed),
        tap(() => {
            this.authService.sessionExpiredInProgress = false;
            this.authService.redirectToLogin();
        })
    ), { dispatch: false });

    addPasskey$ = createEffect(() => this.actions$.pipe(
        ofType(addPasskey),
        tap(() => this.authService.addPasskey())
    ), { dispatch: false });

    addSocialLink$ = createEffect(() => this.actions$.pipe(
        ofType(addSocialLink),
        tap((action) => this.authService.addSocialLink(action.provider))
    ), { dispatch: false });

    removeSocialLink$ = createEffect(() => this.actions$.pipe(
        ofType(removeSocialLink),
        mergeMap((action) => {
            const removalConfirmation = this.snackbar.open(
                $localize`Disconnect this linked account?`,
                $localize`Unlink`,
                { duration: 7000 }
            );
            return merge(
                removalConfirmation.onAction().pipe(
                    take(1),
                    map(() => removeSocialLinkConfirmed({ provider: action.provider }))
                ),
                removalConfirmation.afterDismissed().pipe(
                    take(1),
                    filter((dismissed) => !dismissed.dismissedByAction),
                    map(() => removeSocialLinkCancelled())
                )
            );
        })
    ));

    removeSocialLinkConfirmed$ = createEffect(() => this.actions$.pipe(
        ofType(removeSocialLinkConfirmed),
        tap((action) => this.authService.removeSocialLink(action.provider))
    ), { dispatch: false });
}
